import { View, ViewDensity } from "@common/types/views/views";
import { ViewConfig } from "@lib/views";
import { CoaMappingRow } from "./coaMappingRowTypes";
import { CoaMappingNameCell } from "./cells/CoaMappingNameCell";
import { CoaMappingAccountCell } from "./cells/CoaMappingAccountCell";
import { CoaMappingTypeCell } from "./cells/CoaMappingTypeCell";
import { CoaMappingGroupCell } from "./cells/CoaMappingGroupCell";
import { CoaMappingStatusCell } from "./cells/CoaMappingStatusCell";

export enum CoaMappingColumn {
    NAME = "name",
    ACCOUNT = "account",
    TYPE = "type",
    GROUP = "group",
    STATUS = "status",
}

export type CoaMappingViewConfig = ViewConfig<
    CoaMappingRow,
    CoaMappingColumn,
    never
>;

export const createCoaMappingViewConfig = ({
    providerLabel,
}: {
    providerLabel: string;
}): CoaMappingViewConfig => ({
    columns: {
        [CoaMappingColumn.NAME]: {
            accessorKey: "name",
            name: `${providerLabel} account`,
            header: `${providerLabel} account`,
            cell: CoaMappingNameCell,
            immutable: true,
            minSize: 320,
            maxSize: 1200,
        },
        [CoaMappingColumn.ACCOUNT]: {
            accessorKey: "id",
            name: "Account",
            header: "Account",
            cell: CoaMappingAccountCell,
            minSize: 240,
            maxSize: 600,
        },
        [CoaMappingColumn.TYPE]: {
            accessorKey: "id",
            name: "Type",
            header: "Type",
            cell: CoaMappingTypeCell,
            minSize: 160,
            maxSize: 320,
        },
        [CoaMappingColumn.GROUP]: {
            accessorKey: "id",
            name: "Group",
            header: "Group",
            cell: CoaMappingGroupCell,
            minSize: 200,
            maxSize: 600,
        },
        [CoaMappingColumn.STATUS]: {
            accessorKey: "id",
            name: "Status",
            header: "Status",
            cell: CoaMappingStatusCell,
            minSize: 150,
            maxSize: 200,
        },
    },
    nesting: {
        enabled: true,
        expandColumn: CoaMappingColumn.NAME,
        childrenKey: "children",
    },
});

export const buildCoaMappingView = ({
    hasKickGroups,
}: {
    hasKickGroups: boolean;
}): View => ({
    columns: [
        { id: CoaMappingColumn.NAME, options: { pin: "left" } },
        { id: CoaMappingColumn.ACCOUNT },
        { id: CoaMappingColumn.TYPE },
        ...(hasKickGroups ? [{ id: CoaMappingColumn.GROUP }] : []),
        { id: CoaMappingColumn.STATUS },
    ],
    filters: {},
    options: {
        density: ViewDensity.MD,
    },
});

export const buildCoaMappingSourceView = (): View => ({
    columns: [{ id: CoaMappingColumn.NAME, options: { minSize: 0 } }],
    filters: {},
    options: {
        density: ViewDensity.MD,
    },
});
